Ext.define('SA.TimeSeriesController', {
    extend: 'SA.ViewController',

    constructor() {
        this.callParent(arguments);

        this.bindEvents();
    },

    createDefaultView() {
        var filteringMenuCfg = {xtype: 'filters-window', projectView: this.model};

        this.toolbar = new SA.view.TimeSeriesToolbar({model: this.model, filteringMenuCfg});

        this.toolbar.on('change:attribute', this.onAttributeComboChange, this);
        this.toolbar.on('change:projections', this.onProjectionsDropdownChange, this);
        this.toolbar.on('change:sort', this.onSortDropdownChange, this);
        this.toolbar.on('click:transpose', this.onClickTranspose, this);
        this.toolbar.on('activate:exportBtn', this.onActivateExportBtn, this);

        this.refreshToolbar();

        return SA.ProjectView.createHidden({
            xtype: this.model.isTransposed() ? 'time-series-report-transposed-grid' : 'time-series-report-grid',
            projectView: this.model
        });
    },

    createEditView() {
        this.editController = new SA.TimeSeriesEditController(this.getEditControllerParams());

        return SA.ProjectView.createHidden(this.editController.getView());
    },

    bindEvents() {
        this.mon(this.model, 'change:attribute', this.refreshToolbar, this);
        this.mon(this.model, 'change:location', this.refreshToolbar, this);
        this.mon(this.model, 'change:sort', this.refreshToolbar, this);
        this.mon(this.model, 'change:filter', this.refreshToolbar, this);
        this.mon(this.model, 'change:filterVisibility', this.refreshToolbar, this);

        this.mon(this.model.getProject(), 'change:attribute', this.refreshToolbar, this);
        this.mon(SA.data.LocationAliases, 'change', this.refreshToolbar, this);
    },

    onActivateExportBtn(toolbarButton) {
        var config = new SA.TimeSeriesExportConfig({model: this.model});

        Ext.widget({xtype: 'arrow-export-menu', config, toolbarButton});
    },

    onActive() {
        SA.SidebarState.create()
            .enableTabs(['locations', 'data'])
            .selectTab(SA.Sidebar.lastClickedLocationsTab() ? 'locations' : 'data')
            .setModel(this.model)
            .apply();
    },

    onAttributeComboChange(attribute) {
        this.model.addAttribute(attribute);
        this.model.save();

        SA.data.RecentAttributes.add(attribute);
    },

    onClickTranspose() {
        this.projectViews.destroyViewMode();

        this.model.toggleTransposed();

        this.refreshToolbar();
        this.showView('view');
    },

    onProjectionsDropdownChange(bool) {
        this.model.setIncludeProjections(bool);
    },

    onSortDropdownChange(id) {
        this.model.setSort(SA.data.LocationsCache.toLocationItem(id));
        this.model.save();
    },

    async refreshToolbar() {
        var getLocationId = location => SA.data.LocationsCache.toId(location),
            locations = SA.data.LocationsCache.get(this.model.getLocations()),
            attributesPromise = this.attributesPromise = SA.data.AttributesCache.getPromise(this.model.getSupportedProjectAttributes()),
            attributes = await attributesPromise;

        if (!this.toolbar || attributesPromise !== this.attributesPromise || !this.model.isViewable()) {
            return;
        }

        this.toolbar.setState({
            attributeItems: attributes.map(({attribute, name, year}) => ({attribute, name, year})),
            attributeValue: SA.data.AttributesCache.get(this.model.getAttribute()).attribute,
            canSort: !this.model.isTransposed(),
            includeProjections: this.model.getIncludeProjections(),
            sortItems: [null, '-', ...locations.map(locationToItem)],
            sortValue: getLocationId(this.model.getSortLocation()),
            filtered: this.model.isFiltered()
        });

        function locationToItem(location) {
            return {
                id: getLocationId(location),
                name: location.name,
                locationAlias: location.locationAlias
            };
        }
    }
});